import React from "react";
import { NavLink, } from "react-router-dom";
import { toast, } from 'react-toastify'
import withStyles from "@material-ui/core/styles/withStyles";
import Contacts from "@material-ui/icons/Contacts";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import { fetchData } from '../../utils/handleApi'

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nameState: "",
      emailAddressState: "",
      passwordState: "",
      confirmPasswordState: "",
      name: "",
      emailAddress: "",
      password: "",
      confirmPassword: "",
      showErrMessage: false,
      
      required: "",
      requiredState: "",
      typeEmail: "",
      typeEmailState: "",
      number: "",
      numberState: "",
      url: "",
      urlState: "",
      equalTo: "",
      whichEqualTo: "",
      equalToState: "",
      
      minLength: "",
      minLengthState: "",
      maxLength: "",
      maxLengthState: "",
      range: "",
      rangeState: "",
      minValue: "",
      minValueState: "",
      maxValue: "",
      maxValueState: "",

      showDialogForResetPassword : false,
    };
  }

  componentDidMount(){

    fetchData('admin/myDetails', 'get').then(data => {
      if(data.err){
        return toast.error('Some error happened!')
      }
      this.setState({
        name: data.username,
        nameState: 'success',
        emailAddress: data.email_id,
        emailAddressState: 'success',
      })
    })
  }
  
  verifyEmail(value) {
    let emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }
  
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  
  compare(string1, string2) {
    if (string1 === string2) {
      return true;
    }
    return false;
  }
  
  verifyNumber(value) {
    let numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  }
  
  verifyUrl(value) {
    try {
      new URL(value);
      return true;
    } catch (_) {
      return false;
    }
  }

  change(event, stateName, type, stateNameEqualTo, maxValue) {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 1)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "equalTo":
        if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "checkbox":
        if (event.target.checked) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "number":
        if (this.verifyNumber(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "length":
        if (this.verifyLength((event.target.value).replace(/ /g,""), stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } 
        else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "max-length":
        if (!this.verifyLength(event.target.value, stateNameEqualTo + 1)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "url":
        if (this.verifyUrl(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "min-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "max-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value <= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "range":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo &&
          event.target.value <= maxValue
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      default:
        break;
    }
    switch (type) {
      case "checkbox":
        this.setState({ [stateName]: event.target.checked });
        break;
      default:
        this.setState({ [stateName]: event.target.value });
        break;
    }
  }

  updateProfile = () => {
    let isValid = true

    if (this.state.name.trim() === "") {
      this.setState({ nameState: "error" });
      isValid = false
    }
    if (this.state.emailAddress.trim() === "") {
      this.setState({ emailAddressState: "error" });
      isValid = false
    }

    if(isValid){
      fetchData('admin/update', 'post', {
        username: this.state.name.trim(),
        email_id: this.state.emailAddress.toLowerCase()
      })
      .then(data => {
        if(data.err){
          return toast.error('Some error happened!')
        }
        toast.success('Profile updated successfully!')
      })
    }
  }
  
  disableSpaceBar = (e) => {
      if(e.keyCode === 32){
        e.preventDefault();
      }
  }

  resetPassword = () => {
    let isValid = true;

    if(!this.compare(this.state.password, this.state.confirmPassword)){
      this.setState({ passwordState: "error", confirmPasswordState: "error", showErrMessage: true})
      isValid = false;
    } else if(this.compare(this.state.password, this.state.confirmPassword)){
      this.setState({ passwordState: "success", confirmPasswordState: "success", showErrMessage: false})
      isValid = true;
    }

    if(isValid){
      fetchData('admin/update', 'post', {
        username: this.state.name,
        email_id: this.state.emailAddress.toLowerCase(),
        password: this.state.password,
      })
      .then(data => {
        if(data.err){
          return toast.error('Some error happened!')
        }
        this.setState({
          showDialogForResetPassword: false,
          showErrMessage: false,
          password: "", confirmPassword: "",
          passwordState: "", confirmPasswordState: "",
        }, () => {
          toast.success('Password reset successfully!')
        })
      })
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="success">
                <Contacts />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Profile</h4>
              <Button 
                onClick={() => this.setState({ showDialogForResetPassword: true})}
                style={{
                  float: 'right',
                  backgroundColor: "rgb(4, 171, 35)",
                  marginLeft: "1rem"
                }}
              >
                Reset Password
              </Button>
              <NavLink to="/admin/vendors"> 
              <Button 
                style={{
                  float: 'right',
                  backgroundColor: "rgb(4, 171, 35)"
                }}
              >
                Back
              </Button>
              </NavLink>
            </CardHeader>
            <CardBody>
              <form>
                <CustomInput
                  success={this.state.nameState === "success"}
                  error={this.state.nameState === "error"}
                  labelText="User Name *"
                  id="name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "name", "length", 1),
                    type: "text",
                    value: this.state.name
                  }}
                />
                <CustomInput
                  success={this.state.emailAddressState === "success"}
                  error={this.state.emailAddressState === "error"}
                  labelText="User Email Address *"
                  id="emailAddress"
                  formControlProps={{
                    fullWidth: true,
                    style: { borderBottom: '1px solid #04ab23' }
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "emailAddress", "email"),
                    type: "email",
                    value: this.state.emailAddress,
                    readOnly: true,
                    disabled: true,
                  }}
                />
                <div className={classes.center}>
                  <Button style={{backgroundColor: "rgb(4, 171, 35)"}} onClick={this.updateProfile}>
                    Save
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </GridItem>
        <Dialog
          className={classes.dialog}
          open={this.state.showDialogForResetPassword}
          onClose={() => this.setState({ showDialogForResetPassword: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{backgroundColor: "green", fontSize: "18px", color: "white"}}>
            <p style={{color: "white"}}>Reset Password</p>
          </DialogTitle>
            <DialogContent style={{marginTop: "10px"}}>
              <form>
                <CustomInput
                  success={this.state.passwordState === "success"}
                  error={this.state.passwordState === "error"}
                  labelText="New Password *"
                  helpText={"Minimum 6 characters required"}
                  id="password"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "password", "password"),
                    type: "password",
                    onKeyDown: (e) => this.disableSpaceBar(e),
                    value: this.state.password,
                  }}
                />
                <CustomInput
                  success={this.state.confirmPasswordState === "success"}
                  error={this.state.confirmPasswordState === "error"}
                  labelText="Confirm New Password *"
                  id="confirmPassword"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "confirmPassword", "password"),
                    type: "password",
                    onKeyDown: (e) => this.disableSpaceBar(e),
                    value: this.state.confirmPassword,
                  }}
                />
                {this.state.showErrMessage && <span style={{ fontSize:"12px", color:"red"}}>Passwords don't match</span>}
                <div className={classes.center}>
                  <Button 
                    style={{ backgroundColor: "rgb(4, 171, 35)"}}
                    disabled={this.state.password.length < 6 || this.state.confirmPassword.length < 6}
                    onClick={this.resetPassword}>
                      Save
                  </Button>
                </div>
              </form>
          </DialogContent>
        </Dialog>
      </GridContainer>
    );
  }
}

export default withStyles(validationFormsStyle)(Profile);
